import _constant from './constants';

export const numberWithCommas = x => {
  if (x === undefined || x == null) {
    return '';
  }
  let numbers = x.toString().split('.');
  let output = '';
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, '');
    numbers[0] = isNaN(parseInt(numbers[0])) ? '' : parseInt(numbers[0]);
    if (numbers[0]) {
      if (numbers[0] >= 100000000) {
        numbers[0] = parseInt(`${numbers[0]}`.substring(0, 8));
      }
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString('en-in');
      } else {
        output = numbers[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, '');
    }
    output = `${output}.${numbers[1].substring(0, 2)}`;
  }
  return output;
};

export const isNullOrUndefined = val => {
  return val === undefined || val === null;
};

export const numberWithoutCommas = (number) => {
    if(isNullOrUndefined(number))
    {
        return '';
    }
    return (""+number).replace(/\,/g, '');
}

export const formatTotalAmount = x => {
  if (x === undefined || x == null) {
    return '';
  }
  let numbers = x.toString().split('.');
  let output = '';
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, '');
    numbers[0] = isNaN(parseInt(numbers[0])) ? '' : parseInt(numbers[0]);
    if (numbers[0]) {
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString('en-in');
      } else {
        output = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, '');
    }
    output = `${output}.${numbers[1].substring(0, 2)}`;
  }
  return output;
};

/**
 * obj is the object in which you want to find the key
 * path is the key you want to find
 * default value is the one which you want to return if no value is found
 */
export const getKey = (obj, path, defaultValue) => {
  const result = String.prototype.split
    .call(path, /[,[\].]+?/)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  return result === undefined || result === obj ? defaultValue : result;
};

export const getMonthNameDate = (inputDate, format = _constant.DMY_FORMAT, monthType = 'full') => {
  if (!inputDate) {
    return '';
  }
  const date = inputDate.split('/');
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  if (date.length === 3) {
    let day = Number(date[0]);
    let year = date[2];
    let month = monthType === 'short' ? monthNames[date[1] - 1].substring(0, 3) : monthNames[date[1] - 1];
    if (format === _constant.YMD_FORMAT) {
      year = date[0];
      day = Number(date[2]);
    }
    return `${day} ${month} ${year}`;
  }
  return '';
};



// WEBPACK FOOTER //
// ./utils/utility.js